import request from 'superagent';

import { errorToast, loadingToast, successToast } from './toasts';
import { LS_SHOW_SECRET_POLICY } from '@/constants/common';
import * as types from '@/redux/actionTypes';
import { checkResponse, setLocalStorage } from '@/utils/common';
import { getI18n } from '@/utils/i18n';

const i18n = getI18n();

function updateMe(me, loggedIn = true) {
  return {
    type: types.UPDATE_ME,
    payload: { ...me, loggedIn },
  };
}

function fail(errorInfo) {
  return {
    type: types.UPDATE_ME,
    payload: { ...errorInfo, loggedIn: false },
  };
}

export function deleteMe() {
  return {
    type: types.UPDATE_ME,
    payload: {},
  };
}

/**
 * @desc 新登录接口，每次登录都需要图形验证
 * @param {{
 *   email: string;
 *   pwd: string;
 *   captcha?: string;
 * }} options
 * @param {Function} onSuccess
 * @param {Function} onFail
 * */
export function newLogin(options, onSuccess = () => {}, onFail = () => {}) {
  const { email, pwd, captcha = '' } = options;
  return (dispatch) => {
    request
      .post('/api/headhunters/v2/login')
      .send({ email, password: pwd, captcha })
      .end((err, res) => {
        checkResponse(err, res, false)
          .then((me) => {
            dispatch(updateMe(me));
            setLocalStorage(LS_SHOW_SECRET_POLICY, true);
            onSuccess();
          })
          .catch((error) => {
            onFail(error);
            dispatch(fail(error, false));
          });
      });
  };
}

export function login({ email, pwd }, onSuccess = () => {}) {
  return (dispatch) => {
    request
      .post('/api/headhunters/login')
      .send({ email, password: pwd })
      .end((err, res) => {
        checkResponse(err, res, false)
          .then((me) => {
            onSuccess();
            return dispatch(updateMe(me));
          })
          .catch((errorInfo) => dispatch(fail(errorInfo, false)));
      });
  };
}
export function updatePassword(oldPassword, newPassword, callback = () => {}) {
  return (dispatch) => {
    const toastId = Date.now();
    dispatch(loadingToast(i18n.t`正在修改密码...`, toastId));
    request
      .put('/api/headhunters/update_password')
      .send({ oldPassword, newPassword })
      .end((err, res) => {
        checkResponse(err, res)
          .then(() => {
            callback();
            dispatch(successToast(i18n.t`密码已修改`, toastId));
          })
          .catch((error) => {
            callback(error);
            dispatch(errorToast(i18n.t`修改密码失败：` + error, toastId));
          });
      });
  };
}

export function switchLocale(locale) {
  return (dispatch) => {
    request
      .post('/api/headhunters/switch_language')
      .send({ locale })
      .end((err, res) => {
        checkResponse(err, res)
          .then(() => {
            dispatch(successToast(i18n.t`msg.SWITCH_LOCALE_SUCCESS_IN_NEXT_LOCALE`));
            setTimeout(() => window.location.reload(), 200);
          })
          .catch(() => {
            dispatch(errorToast(i18n.t`msg.TOAST_OPERATION_FAILED`));
          });
      });
  };
}
